module.exports = __webpack_public_path__ + "static/media/HCMM373.6ae2da15.jpg";